import locale from 'modules/landingPages/presentation/locale';
import routes from 'modules/landingPages/presentation/routes';

const module = {
  locale,
  routes,
};

export default module;
